import Videos from './index.vue'
export { useVideosStore } from './store/videosStore'

export default Videos
